const renderConfigure = (renderOptions, isFirstRender) => {
	const { refine, widgetParams } = renderOptions;
  
	if (isFirstRender) {
	  const select = document.getElementById('results-limiter');
	  select.addEventListener('change', () => {
			let value = Number( select.value );
			if (value > 40 ) {
				value = 40;
			}
			refine({
				hitsPerPage: value,
				filters: widgetParams.searchParameters.filters,
				facetingAfterDistinct: true,
			});
	  });
	}
  };
  
  // Create the custom widget
  const customConfigure = instantsearch.connectors.connectConfigure(
	renderConfigure,
	() => {}
  );

export default customConfigure;